import React from "react";
import { Star } from "lucide-react";

/**
 * Small, subtle "PRO" pill placed next to a gated feature label so users
 * understand which experiences deepen with N8One Pro. Do NOT sprinkle
 * these across the app — only where a feature is actually being gated
 * or previewed.
 */
export default function ProBadge({ className = "", testid = "pro-badge" }) {
  return (
    <span
      data-testid={testid}
      title="N8One Pro feature"
      aria-label="Pro feature"
      className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-[hsl(var(--clay))]/15 text-[hsl(var(--clay))] text-[9px] uppercase tracking-[0.16em] font-medium align-middle ${className}`}
    >
      <Star size={8} fill="currentColor" /> Pro
    </span>
  );
}
